// extracted by mini-css-extract-plugin
export default {"root":"LicenseRows__root--cG6OEoCu6ymsBHkcrJuf","topRoot":"LicenseRows__topRoot--cQyEto8dGDqpcqW6IANw"};